import { render, staticRenderFns } from "./DocumentVersionBanner.vue?vue&type=template&id=1f5023cd"
import script from "./DocumentVersionBanner.vue?vue&type=script&lang=js"
export * from "./DocumentVersionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports